App.factory('surveyFactory', surveyFactory);

surveyFactory.$inject = [
    'DispatcherService'
];

function surveyFactory(DispatcherService) {
    return {
        all: function() {
            return DispatcherService.get('surveys');
        },

        find: function(surveyId) {
            return DispatcherService.get('surveys/' + surveyId);
        },

        questions: function(surveyId) {
            return DispatcherService.get('surveys/' + surveyId + '/questions');
        }
    };
}
